<template>
  <div>
    <div v-for="(item, index) in busList" :key="index" class="item">
      {{ item.add_time }}
    </div>
  </div>
</template>

<script>
import { usageRecordApi } from "@api/login";
export default {
  data() {
    return {
      busList: [],
    };
  },
  mounted() {
    this.getUsage();
  },
  methods: {
    getUsage() {
      let id = this.$route.query.id;
      console.log(id);
      usageRecordApi({ bus_card_id: id }).then((res) => {
        console.log(res);
        this.busList = res.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  box-sizing: border-box;
  padding: 10px;
}
</style>
